// CJM Admin forms intake — shared by every form on the site. Defaults to the
// real deployed domain; VITE_PORTAL_URL in .env.local overrides it for local
// dev against a locally-running CJM Admin instance.
export const PORTAL_URL = import.meta.env.VITE_PORTAL_URL || 'https://admin.cjmstudios.com'
// Site key for "cjmstudios" — identifies which site is submitting, not a
// deep secret (it's visible in the client bundle by design, same as a
// Formspree form ID would be). It only allows POSTing form submissions.
export const PORTAL_API_KEY = 'sk_06b21d2baa7d8a2d6a49956aa0b48fd4750a10d3'

export async function submitToPortal(formName, data) {
  return fetch(`${PORTAL_URL}/api/forms/${formName}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Api-Key': PORTAL_API_KEY },
    body: JSON.stringify(data),
  })
}

// CJM Portal (client) — just the link shown in the "brief sent" confirmation.
// Account provisioning itself happens server-to-server (CJM Admin calls CJM
// Portal directly once it's validated and stored the submission) so that no
// client-portal API key ever ships in this browser bundle. Same override
// pattern as PORTAL_URL above via VITE_CLIENT_PORTAL_URL.
export const CLIENT_PORTAL_URL = import.meta.env.VITE_CLIENT_PORTAL_URL || 'https://portal.cjmstudios.com'
